import React from 'react';
import LegendItem, {LegendRowData} from './LegendItem';
import {LegendContainer, LegendInner} from './styles';

type Props = {
    rows: LegendRowData[];
    onClick: (i: number) => void;
    onHover: (i: number) => void;
    onLeave: (i: number) => void;
    rev: number; // чтобы форсить ре-рендер при перерасчёте процентов
    side?: 'left' | 'right';
};

const LegendColumn: React.FC<Props> = ({ rows, onClick, onHover, onLeave, side = 'left' }) => {
    return (
        <LegendContainer side={side}>
            <LegendInner side={side}>
                {rows.map((row) => (
                    <LegendItem
                        key={row.i}
                        row={row}
                        onClick={onClick}
                        onHover={onHover}
                        onLeave={onLeave}
                    />
                ))}
            </LegendInner>
        </LegendContainer>
    );
};

export default LegendColumn;